import { Outlet } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { CookieConsent } from "@/components/CookieConsent";
import { AuthModal } from "@/components/AuthModal";

export function Layout() {
  return (
    <div className="flex min-h-screen flex-col bg-[#08090E]">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
      <AuthModal />
      <CookieConsent />
    </div>
  );
}
